import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2l0 -16","key":"svg-0"}]]

const IconBrandBing = createReactComponent('outline', 'brand-bing', 'BrandBing', __iconNode);

export default IconBrandBing;